/**
 * 客户端版本的 storeUtils
 * 通过 API 调用获取店铺信息，而不是直接访问数据库
 */

import api from './api';

/**
 * 获取所有可用的店铺列表（客户端版本）
 */
export const getAllAvailableStores = async (): Promise<Array<{id: number, name?: string}>> => {
  try {
    const response = await api.get('/stores/from-keys');
    const stores = Array.isArray(response.data) ? response.data : [];
    const validStores: Array<{ id: number; name?: string }> = [];
    for (const store of stores) {
      const rawId = store?.id ?? store?.store_id;
      const id = typeof rawId === 'string' ? parseInt(rawId, 10) : Number(rawId);
      if (!Number.isFinite(id) || id <= 0) continue;
      validStores.push({
        id,
        name: store?.name || store?.store_name || `店铺 ${id}`
      });
    }
    return validStores;
  } catch (error) {
    console.error('获取可用店铺列表时出错:', error);
    return [];
  }
};

/**
 * 获取当前store_id（客户端版本）
 * 返回第一个可用的店铺ID
 */
export const getStoreId = async (): Promise<number> => {
  try {
    const stores = await getAllAvailableStores();
    const firstValidStore = stores.find((store) => Number.isFinite(store.id) && store.id > 0);
    if (firstValidStore) return firstValidStore.id;

    throw new Error('没有可用的店铺');
  } catch (error) {
    console.error('获取store_id时出错:', error);
    throw error;
  }
};

/**
 * 查找包含指定商品的店铺（客户端版本）
 * 注意：这个函数在客户端无法完全实现，需要后端支持
 */
export const findStoreWithProduct = async (articuloID: string | number, currentStoreId?: number): Promise<number | null> => {
  void articuloID;
  void currentStoreId;
  // 这里需要一个后端 API 端点来查找商品所在的店铺
  // 暂时返回 null，表示未实现
  return null;
};

/**
 * 获取当前almacenID（客户端版本）
 * 这个函数在客户端环境中返回默认值
 */
export const getAlmacenID = async (): Promise<number> => {
  // 在客户端环境中，返回默认值
  return 1;
};
